import { render, staticRenderFns } from "./GoodsBaseInfo.vue?vue&type=template&id=6f7b1288&scoped=true"
import script from "./GoodsBaseInfo.vue?vue&type=script&lang=ts"
export * from "./GoodsBaseInfo.vue?vue&type=script&lang=ts"
import style0 from "./GoodsBaseInfo.vue?vue&type=style&index=0&id=6f7b1288&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7b1288",
  null
  
)

export default component.exports